import styled from 'styled-components'

export const List = styled.div<{ $isInbound: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${({ $isInbound }) => ($isInbound ? 'flex-start' : 'flex-end')};
  gap: 4px;
  max-width: 52ch;
  margin-top: 4px;
`
